import html2canvas from 'html2canvas';
import { jsPDF } from 'jspdf';

// Business card size: 88.9mm x 50.8mm (3.5in x 2in).
const CARD_SIZE_MM = { width: 88.9, height: 50.8 };

const captureCard = async (node) =>
  html2canvas(node, {
    scale: 3,
    backgroundColor: '#ffffff',
    useCORS: true,
    logging: false,
  });

export const exportBusinessCardPdf = async ({ frontNode, backNode, fileName }) => {
  if (!frontNode || !backNode) {
    throw new Error('Business card preview not ready.');
  }

  const frontCanvas = await captureCard(frontNode);
  const backCanvas = await captureCard(backNode);

  const pdf = new jsPDF({
    orientation: 'landscape',
    unit: 'mm',
    format: [CARD_SIZE_MM.width, CARD_SIZE_MM.height],
  });

  pdf.addImage(
    frontCanvas.toDataURL('image/png', 1.0),
    'PNG',
    0,
    0,
    CARD_SIZE_MM.width,
    CARD_SIZE_MM.height,
  );
  pdf.addPage([CARD_SIZE_MM.width, CARD_SIZE_MM.height], 'landscape');
  pdf.addImage(
    backCanvas.toDataURL('image/png', 1.0),
    'PNG',
    0,
    0,
    CARD_SIZE_MM.width,
    CARD_SIZE_MM.height,
  );

  const outputBlob = pdf.output('blob');
  pdf.save(fileName || 'Douglas-McCartney-Business-Card.pdf');

  return outputBlob;
};

export const BUSINESS_CARD_SIZE_MM = CARD_SIZE_MM;
